export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q05_a.14893416.png";